import { decode as base64_decode, encode as base64_encode } from "base-64";
import RootStore from "./RootStore";
import { postApi, baseURL } from "../components/Utility";
import { action, makeObservable, observable } from "mobx";
import config from "../config";
import { message } from "antd";

class ExIdleReportStore {
  exIdleReport = [];
  totalReport = [];
  total = 0;
  loading = false;
  rootStore;
  remaning_vehicleId = ""
  last_record_timestamp = ""
  pythonReportErrorMessage= false
  pythonReportMessage = false
  constructor(rootStore) {
    makeObservable(this, {
      exIdleReport: observable,
      totalReport: observable,
      total: observable,
      loading: observable,
      loadData: action,
      exportcsv: action,
      exportExcel: action,
      exportpdf: action,
      exportxml: action,
      loadDataTotal: action,
      remaning_vehicleId: observable,
      last_record_timestamp: observable,
      pythonReportMessage: observable,
      pythonReportErrorMessage:observable
    });
    this.rootStore = rootStore;
  }

  async loadData({
    companyId,
    offset,
    limit,
    vehicleId,
    fromDate,
    toDate,
    interval,
    pageNo,
  }) {
    this.loading = true;
    // console.log("Ex-Idle Report", fromDate, toDate);
    var postData = {
      companyId: companyId,
      vehicleId: vehicleId,
      fromDate: fromDate,
      toDate: toDate,
      interval: interval,
      offset: offset,
      limit: limit,
      page: pageNo,
    };

    if (config.pythonReport === 1) {
      // postData.companyId=10166
      // postData.vehicleId=[26375]
      if (offset === 0) {
        postData.last_record_timestamp = ""
        postData.remaning_vehicleId = ""
      } else {
        postData.last_record_timestamp = this.last_record_timestamp
        postData.remaning_vehicleId = this.remaning_vehicleId
      }
      var response = await postApi.getClient('report').post("/report/exidle", postData);
      this.total = 500

    } else {
      const base64Input = await base64_encode(JSON.stringify(postData));
      var response = await postApi.getClient().post("index.php?c=vehicleidle&a=exidlerep", "postData=" + base64Input);
      this.total = parseInt(response?.data?.data?.TotalCount);
    }

    if (config.pythonReport === 1) {
      this.last_record_timestamp = response?.data?.data?.last_record_timestamp
      this.remaning_vehicleId = response?.data?.data?.remaning_vehicleId
    }

    this.exIdleReport = response?.data?.data?.ExidleRep;
    this.loading = false;

  }

  async loadDataTotal({
    companyId,
    offset,
    limit,
    vehicleId,
    fromDate,
    toDate,
    interval,

  }) {

    if (config.pythonReport !== 1) {
      this.loading = true;
      // console.log("Ex-Idle Report", fromDate, toDate);
      var postData = {
        companyId: companyId,
        vehicleId: vehicleId,
        fromDate: fromDate,
        toDate: toDate,
        interval: interval,
        offset: offset,
        limit: limit,

      };
      const base64Input = await base64_encode(JSON.stringify(postData));
      var response = await postApi
        .getClient()
        .post("index.php?c=vehicle&a=totalExIdleRep", "postData=" + base64Input);
      // console.log("exidle ",response?.data?.data);
      this.totalReport = response?.data?.data;
      this.loading = false;
    }

  }
  async exportExcel(getData) {

    if (config.pythonReport === 1) {

      getData = { ...getData, language: "english" }
      // getData = { ...getData, companyId: 10166 }
      // getData = { ...getData, vehicleId: [26375] }
      try {

        await postApi.getClient("report").post("/report/exidle/download/excel", getData, {
          responseType: "blob",
        });
        this.pythonReportMessage = true;
        // await message.success("The report will be generated shortly. You can check its status in the pending report list.", 2);

      } catch (error) {
        this.pythonReportErrorMessage = false;
        message.error("Failed to download the report. Please try again.")
      }

    } else {

      let lang = "english";
      window.location.href =
        baseURL +
        "index.php?c=vehicleidle&a=exportexidleexcel&cid=" +
        getData.companyId +
        "&userId=" +
        getData.userId +
        "&vid=" +
        getData.vehicleId +
        "&int=" +
        getData.interval +
        "&fD=" +
        getData.fromDate +
        "&tD=" +
        getData.toDate +
        "&colList=" +
        getData.colList +
        "&language=" +
        lang;

    }

  }

  async exportcsv(getData) {
    window.location.href =
      baseURL +
      "index.php?c=vehicleidle&a=exportexidlecsv&cid=" +
      getData.companyId +
      "&userId=" +
      getData.userId +
      "&vid=" +
      getData.vehicleId +
      "&int=" +
      getData.interval +
      "&fD=" +
      getData.fromDate +
      "&tD=" +
      getData.toDate +
      "&colList=" +
      getData.colList;
  }

  async exportpdf(getData) {

    if (config.pythonReport === 1) {

      getData = { ...getData, language: "english" }
      // getData = { ...getData, companyId: 10166 }
      // getData = { ...getData, vehicleId: [26375] }
      try {

        await postApi.getClient("report").post("/report/exidle/download/pdf", getData, {
          responseType: "blob",
        });
        this.pythonReportMessage = true;
        // await message.success("The report will be generated shortly. You can check its status in the pending report list.", 2);

      } catch (error) {
        this.pythonReportErrorMessage = false;
        message.error("Failed to download the report. Please try again.")
      }

    } else {
      let lang = "english";
      window.location.href =
        baseURL +
        "index.php?c=vehicleidle&a=exportexidlepdf&cid=" +
        getData.companyId +
        "&userId=" +
        getData.userId +
        "&vid=" +
        getData.vehicleId +
        "&int=" +
        getData.interval +
        "&fD=" +
        getData.fromDate +
        "&tD=" +
        getData.toDate +
        "&colList=" +
        getData.colList +
        "&language=" +
        lang;
    }

  }

  async exportxml(getData) {
    window.location.href =
      baseURL +
      "index.php?c=vehicleidle&a=exportexidlexml&cid=" +
      getData.companyId +
      "&userId=" +
      getData.userId +
      "&vid=" +
      getData.vehicleId +
      "&int=" +
      getData.interval +
      "&fD=" +
      getData.fromDate +
      "&tD=" +
      getData.toDate +
      "&colList=" +
      getData.colList;
  }
}

export default ExIdleReportStore;
